<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="lg_left">
          <div class="headPhoto">
            <el-image class="photo" :src="url" :preview-src-list="srcList">
            </el-image>
          </div>
          <div class="likeCount">
            <div class="likeCount-item" @click="like">
              <img
                v-if="productItem.isColl > 0"
                src="../../assets/images/like1_on.png"
                alt=""
              />
              <img v-else src="../../assets/images/like1.png" alt="" />
              <div>收藏</div>
            </div>
            <!-- <div class="line"></div>
            <div class="likeCount-item">
              <img src="../../assets/images/hate1.png" alt="" />
              <img  src="../../assets/images/hate1.png" alt="" />
              <div>不喜欢</div>
            </div> -->
          </div>
          <div class="desc">
            <div>服务承诺</div>
            <div>正品保证 急速退款 退货运费险</div>
          </div>
        </div>
        <div class="lg_right">
          <div class="name">
            {{ productItem.name }}
          </div>
          <div class="money">{{ productItem.originalPrice }}</div>
          <div class="sale">
            <div class="item">
              月销量 <span>{{ productItem.saleCount }}</span>
            </div>
            <!-- <div class="line"></div>
            <div class="item">累计评价 <span>0</span></div> -->
          </div>
          <div class="sort_title" v-for="(item, index) in skulist" :key="index">
            <div class="sort_h1">{{ item.name }}</div>
            <ul class="sort_list">
              <li
                v-for="(items, i) in item.skus"
                :key="i"
                @click="selectItemHandle(items, i, item.id)"
                :class="selectSkuVal.indexOf(`_${items.id}_`) > -1 ? 'on' : ''"
              >
                {{ items.skuName }}
              </li>
            </ul>
          </div>
          <!-- <div class="sort_title">
            规格分类
            <ul class="sort_list">
              <li>1-2人用小饭锅(机械型)</li>
            </ul>
          </div> -->
          <div class="sort_title">数量</div>
          <div class="oper">
            <div class="poer_con">
              <div class="amount">
                <!-- <div class="less"></div>
              <input type="namuber" class="num" />
              <div class="plus"></div> -->
                <el-input-number
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </div>
              <div class="stock">库存({{ productItem.stock }})</div>
            </div>
          </div>
          <div class="product-info-btns">
            <div class="product-info-incart" @click="addCart(0)">
              <img
                class="product-info-incart-icon"
                src="../../assets/images/cart_1.png"
                alt=""
              />
              <div>加入购物车</div>
            </div>
            <div class="product-info-buynow" @click="addCart(1)">立即购买</div>
          </div>
        </div>
      </div>
      <div class="introducePhoto">
        <custom-swiper
          :imgs="productItem.introducePhotos"
          :loop="false"
          :autoplay="false"
          :pagination="false"
          :slidesPerView="5"
        >
        </custom-swiper>
      </div>
      <div class="view">
        <div class="title_bg">
          商品详情
          <div class="title_arr"></div>
        </div>
        <div class="view_content">
          <el-image
            :src="item"
            contain
            lazy
            v-for="(item, index) in productItem.detailPhotos"
            :key="index"
            style="width: 790px"
          ></el-image>
          <el-empty
            description="暂无资料"
            v-if="
              productItem.detailPhotos && productItem.detailPhotos.length <= 0
            "
          ></el-empty>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="cust" @click="customerHandle">客服</div> -->
</template>
<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { posts, postNoLoading } from '../../utils/posts'
import crumb from '../../components/bread-crumb/Index.vue'
import CustomSwiper from '../../components/CustomSwiper.vue'
import { ElMessage } from 'element-plus'
export default {
  name: '详情',
  components: {
    crumb,
    CustomSwiper
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const user = store.state.userInfo || { uid: 0 }
    const pid = route.query.pid
    const url = ref('')
    const srcList = ref([])
    const productItem = ref({})
    const productColore = ref([]) // 产品颜色
    const productSpecs = ref([]) // 产品规格
    const skulist = ref([]) // sku列表
    const selectSkuVal = ref('')
    const selectSku = ref([])
    const skuDetail = ref({ id: 0 }) // sku详情

    const productHandler = () => {
      posts('product/detail/' + user.uid, { pid: pid }).then((res) => {
        productItem.value = res.data
        store.state.supplierId = productItem.value.supplierId
        // url.value = productItem.value.smallPhoto
        srcList.value = productItem.value.introducePhotos
        productItem.value.stock = 0
      })
    }
    // 收藏
    const like = () => {
      const product = productItem.value
      if (product.isColl > 0) {
        product.isColl = 0
      } else {
        product.isColl = 1
      }
      productItem.value = product
      postNoLoading(`collection/coll/${user.uid}`, { pid: pid }).then(
        (res) => {}
      )
    }

    // 选择商品规格
    const selectItemHandle = (item, index, id) => {
      const obj = {}
      obj.parentid = id
      obj.skuid = item.id
      let ss = 0
      // eslint-disable-next-line no-unused-expressions
      let skuVal = pid + '_'
      const newSelectSku = selectSku.value
      newSelectSku.forEach((item) => {
        // eslint-disable-next-line no-unused-expressions
        item.parentid === obj.parentid
          ? (() => {
            item.skuid = obj.skuid
            ss = 1
          })()
          : ''
        skuVal += item.skuid + '_'
      })
      // eslint-disable-next-line no-unused-expressions
      !ss ? newSelectSku.push(obj) : ''
      selectSkuVal.value = skuVal
      getSkuDetailHandler()
    }
    // 数量输入框
    const num = ref(1)
    const handleChange = (value) => {
      num.value = value
    }

    const getSkuDetailHandler = () => {
      posts('product/skudetail/' + user.uid, {
        goodsId: pid,
        skuVal: selectSkuVal.value
      }).then((res) => {
        productItem.value.originalPrice = res.data.salePrice
        productItem.value.stock = res.data.stock
        skuDetail.value.id = res.data.id
        url.value = res.data.photo
      })
    }

    // 获取sku列表
    const skuHandler = () => {
      posts('product/skulist/' + user.uid, { goodsId: pid }).then((res) => {
        let newSkuVal = pid + '_'
        const datas = res.data
        const newSelectSku = []
        skulist.value = datas
        datas.forEach((item, idx) => {
          const obj = {}
          obj.parentid = item.id
          obj.skuid = item.skus[0].id
          newSkuVal += item.skus[0].id + '_'
          newSelectSku.push(obj)
        })
        newSelectSku.values = newSelectSku
        selectSkuVal.value = newSkuVal
        selectSku.value = newSelectSku
        getSkuDetailHandler()
      })
    }

    // 添加购物车
    const addCart = (buyNow) => {
      if (skuDetail.value.id <= 0) {
        ElMessage({
          showClose: true,
          message: '请选择商品信息',
          type: 'error'
        })
        return
      }
      posts('cart/addcart/' + user.uid, {
        detailId: skuDetail.value.id,
        num: num.value,
        buyNow
      })
        .then((res) => {
          if (buyNow === 1) {
            router.push({
              path: '/product/placeOrder',
              query: { id: res.data }
            }) // 提交订单
          } else {
            ElMessage({
              showClose: true,
              message: '加入购物车成功',
              type: 'success'
            })
          }
        })
        .catch((e) => {})
    }
    productHandler()
    onMounted(() => {
      skuHandler()
    })
    return {
      like,
      skuDetail,
      addCart,
      selectSku,
      selectSkuVal,
      getSkuDetailHandler,
      skuHandler,
      selectItemHandle,
      skulist,
      productSpecs,
      productColore,
      num,
      handleChange,
      productItem,
      url,
      srcList
    }
  }
}
</script>
<style lang="scss" scoped>
.cust {
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 100px;
  height: 100px;
  background: forestgreen;
}
.view {
  .view_content {
    background: white;
    display: flex;
    flex-direction: column;
    padding: 60px 0;
    justify-content: center;
    align-items: center;
    margin: 25px 0 50px 0;
  }
  .title_bg {
    width: 190px;
    padding: 0 20px;
    height: 85px;
    line-height: 85px;
    text-align: center;
    font-size: 28px;
    background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
    opacity: 1;
    color: white;
    position: relative;
    &::before {
      position: absolute;
      content: "";
      width: 14px;
      height: 14px;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
      left: 0;
      right: 0;
      bottom: -7px;
      margin: auto;
      transform: rotate(45deg);
    }
  }
}
.introducePhoto {
  overflow: hidden;
  width: 1200px;
  height: 242px;
}
.lg_right {
  width: 494px;
  margin: 0 30px 0 0;
  .product-info-btns {
    width: 400px;
    height: 68px;
    margin: 24px 0 0 0;
    border-radius: 8px;
    align-items: center;
    display: flex;
    background-color: #fff;

    .product-info-buynow {
      font-size: 20px;
      color: #fff;
      line-height: 56px;
      width: 168px;
      margin-right: 5px;
      background-color: #535353;
      text-align: center;
      border-radius: 8px;
      cursor: pointer;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
    }
    .product-info-incart {
      flex: 1;
      font-size: 20px;
      color: #000;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #7a7a7a;
    }
    .product-info-incart-icon {
      width: 34px;
      height: 32px;
      margin: 0 16px 0 0;
    }
  }
  .oper{
    display: flex;
  }
  .poer_con {
    display: flex;
    align-items: flex-end;
    margin-top: 13px;
    border-radius: 4px;
    padding: 6px;
    background-color: #fff;
     .stock {
      font-size: 10px;
      font-weight: 400;
      color: #3e3a39;
      margin: 0 0 0 8px;
    }

    .amount {
      display: flex;
      justify-content: space-between;
    }
    .amount .less,
    .amount .plus {
      position: relative;
      width: 30px;
      height: 30px;
      border: 1px solid #707070;
      border-radius: 4px;
      cursor: pointer;
    }
    .amount .plus {
      // border-radius: 0 12px 12px 0;
    }
    .amount .less {
      // border-radius: 12px 0 0 12px;
    }

    .amount .less::before,
    .amount .plus::before,
    .amount .plus::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 20px;
      height: 2px;
      background-color: #333;
    }
    .amount .plus::after {
      width: 2px;
      height: 20px;
    }
    .amount .num {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 24px;
      color: #333;
      border: 1px solid #333;
      border-radius: 4px;
      // border-width: 1px 0;
    }
  }
  .sort_list {
    display: flex;
    flex-wrap: wrap;
    li {
      background: #ffffff;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 10px 8px;
      margin: 0 10px 10px 0;
      cursor: pointer;
      font-weight: normal;
      &.on {
        border: 1px solid #fc4353;
      }
    }
  }
  .sort_title {
    margin: 16px 0 6px 0;
    font-size: 18px;
    font-weight: 600;
    color: #777777;
    &.none {
      font-weight: normal;
    }
    .sort_h1 {
      margin: 0 0 16px 0;
    }
  }
  .name {
    line-height: 36px;
    color: #3e3a39;
    font-size: 24px;
  }
  .money {
    font-size: 44px;
    font-weight: bold;
    color: #3e3a39;
    margin: 16px 0 7px 0;
  }
  .money::before {
    content: "¥";
    font-size: 18px;
  }
  .sale {
    width: 400px;
    display: flex;
    color: #999;
    font-size: 18px;
    padding: 6px 0;
    align-items: center;
    justify-content: center;
    border-top: 1px #999 dashed;
    border-bottom: 1px #999 dashed;
    .line {
      width: 1px;
      height: 36px;
      background-color: #767474;
    }
    .item {
      padding: 0 22px;
      position: relative;
      color: #777777;
      line-height: 25px;
      text-align: center;
      span {
        padding: 0 4px;
        color: #fc4353;
      }
    }
  }
}
.container {
  width: 1200px;
}
.lg {
  display: flex;
  margin: 36px 0 0 0;
  justify-content: space-between;
}
.headPhoto {
  width: 600px;
  height: 600px;
  overflow: hidden;
  .photo {
    height: 100%;
    width: 100%;
  }
}
.lg_left {
  .likeCount {
    display: flex;
    padding: 20px 0;
    .likeCount-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      div {
        color: #626060;
        padding: 0 0 0 8px;
      }
    }
  }
  .desc {
    font-size: 18px;
    color: #999;
    font-weight: bold;
    div {
      padding: 20px 0;
    }
  }
}
</style>
